import * as constants from '../constants/searchConstants';

const searchReducer = (state = {inputs:[],errMsg:[]},action)=>{

       switch(action.type)
       {  
           case constants.SEARCH_FETCH:

              return { 
                  ...state,
                  inputs:[ ...action.payload ]
              };
             
           case constants.SEARCH_UPDATE:

              return { 
                ...state,
                inputs:[ ...action.payload ]
              };
          
           case constants.SEARCH_APPEND:

              return {
                  ...state,
                  inputs:[ ...state.inputs,action.payload ]
              }; 
        
           case constants.SEARCH_CHANGE:
               
              //payload:{ _id, description }
              const newInputs = state.inputs.map(x=>{
                   const status = x._id === action.payload._id ? 'Y' :'N';
                   return {...x,status};
              });

              return { ...state,inputs:[ ...newInputs ]};
              
           default:
              return state;
       }
}

export default searchReducer;